/* Mobile disclosure for native Klaviyo controls. No review nodes are moved or replaced. */
(() => {
  const roots = '#klaviyo-product-reviews-wrapper, #klaviyo-all-reviews-wrapper';
  const bound = new Map();
  const update = host => {
    const widgets = host.matches(roots) ? [host] : host.querySelectorAll(roots);
    for (const root of widgets) {
      const tabs = root.querySelector('.kl_reviews__list__tabs');
      const controls = root.querySelector('.kl_reviews__list [role="search"]');
      if (!tabs || !controls) continue;
      if (!controls.id) controls.id = `${root.id}-mobile-controls`;
      let button = tabs.querySelector('.tf-reviews-mobile-toggle');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'tf-reviews-mobile-toggle';
        tabs.append(button);
      }
      let count = controls.querySelector('input[type="text"]')?.value.trim() ? 1 : 0;
      for (const select of controls.querySelectorAll('select')) {
        if (select.id !== 'kl_reviews__sort_by_reviews' && select.selectedIndex > 0) count++;
      }
      count += controls.querySelectorAll('[role="checkbox"][aria-checked="true"]').length;
      const label = count ? `Filter & sort (${count})` : 'Filter & sort';
      if (button.textContent !== label) button.textContent = label;
      button.setAttribute('aria-controls', controls.id);
      button.setAttribute('aria-expanded', String(root.dataset.tfReviewFiltersOpen === 'true'));
      root.dataset.tfReviewsMobile = 'true';
    }
  };
  const bind = host => {
    if (bound.has(host)) return;
    let frame = null;
    const schedule = () => {
      if (frame !== null) return;
      frame = requestAnimationFrame(() => { frame = null; update(host); });
    };
    const click = event => {
      const button = event.target.closest('.tf-reviews-mobile-toggle');
      if (button) {
        const root = button.closest(roots);
        root.dataset.tfReviewFiltersOpen = String(root.dataset.tfReviewFiltersOpen !== 'true');
        update(host);
      } else schedule();
    };
    const observer = new MutationObserver(schedule);
    observer.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-checked'] });
    host.addEventListener('click', click);
    host.addEventListener('input', schedule);
    host.addEventListener('change', schedule);
    bound.set(host, () => {
      observer.disconnect();
      if (frame !== null) cancelAnimationFrame(frame);
      host.removeEventListener('click', click);
      host.removeEventListener('input', schedule);
      host.removeEventListener('change', schedule);
    });
    update(host);
  };
  const init = () => {
    // The product host is present before Klaviyo asynchronously mounts its widget.
    for (const host of document.querySelectorAll('#fulfilled-reviews-all, #klaviyo-all-reviews-wrapper')) bind(host);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    for (const [host, clean] of bound) {
      if (event.target.contains(host)) { clean(); bound.delete(host); }
    }
  });
})();
